var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-1 p-1",staticStyle:{"cursor":"pointer","border":"1px solid black","background-color":"#f0f0f0"},on:{"click":function($event){return _vm.$emit('show')}}},[_c('b-icon',{attrs:{"icon":"eye-slash"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }